import { getCookieValue, rootDomain } from '~/utils/cookie';

export const useCookieBonusType = () => {
  const init = () => {
    if (!window || !import.meta.browser) {
      return;
    }
    const route = useRoute();
    const promoQuery = route.query.promo_type;
    const domain = rootDomain(document.location.hostname);
    if (promoQuery) {
      document.cookie = `promo_type=${promoQuery};Max-Age=63158400;Domain=${domain};Path=/`;
      return;
    }
    if (!getCookieValue('promo_type')) {
      document.cookie = `promo_type=no_dep;Max-Age=63158400;Domain=${domain};Path=/`;
    }
  };

  const remove = () => {
    const domain = rootDomain(document.location.hostname);
    document.cookie = `promo_type=;Max-Age=-1000;Domain=${domain};Path=/`;
  };

  return {
    init,
    remove,
  };
};
